<template >
  <div class="container">
    <br/>
    
    <v-row>
      <v-col cols="4">
    <v-select
      v-model="selectedTemplateId"
      :items="templates"
      item-title="name"
      item-value="id"
      label="請選擇模版編輯"
      
    ></v-select>
  </v-col>
  <v-col cols="auto" class="pa-2">
        <v-btn color="primary" @click="loadTemplate" style="margin-top: 8px; margin-left: 15px;">
          &nbsp;&nbsp;載入模版&nbsp;&nbsp;
        </v-btn>
      </v-col>
      <v-col cols="auto" class="pa-2">
        <v-btn @click="previewResult" color="green" style="margin-top: 8px; margin-left: 15px;">檢視佈局結果</v-btn>
      </v-col>
  
  <v-col cols="auto" class="pa-1">
        <v-btn color="red" icon @click="deleteTemplate" style="margin-top: 2x; margin-left: 15px;">
          <v-icon title="刪除模版">mdi-delete</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto" class="pa-1">
        <v-btn color="purple" icon @click="deleteAllTemplate" style="margin-top: 2px; margin-left: 15px;">
          <v-icon title="清除編輯區">mdi-arrow-up-bold-box-outline</v-icon>
        </v-btn>
      </v-col>
  </v-row>
  <v-row>
    <v-col cols="4">
    <v-text-field
        style="background-color:darkblue"
        v-model="templateName"
        label="模版名稱"
        type="text"
      ></v-text-field>
  </v-col>
  <v-col cols="2"><v-btn color="primary" @click="saveTemplate" style="margin-top:10px; width:150px;">儲存模版</v-btn></v-col>
  
  </v-row>
  <v-row>
      <v-col cols="2" md="2">
        <v-text-field
          v-model="panelWidth"
          label="寬 (px)"
          type="number"
          min="0"
          
        ></v-text-field>
      </v-col>
      <v-col cols="2" md="2">
        <v-text-field
          v-model="panelHeight"
          label="長 (px)"
          type="number"
          min="0"
          
        ></v-text-field>
      </v-col>
      <v-col col="auto">
        <div @drag="drag" @dragend="dragend" class="droppable-element" draggable="true" unselectable="on">
          點選我並拖曳至下方以增加項目
        </div>
      </v-col>
      
    </v-row>
  
    <div id="content">
      <div
      class="panel"
      :style="{ width: (panelWidth+4 < 1860 ? panelWidth+4:1860) + 'px', height: (panelHeight+4) + 'px' }"
      >
      <grid-layout  :style="{ width: (panelWidth) + 'px', height: (panelHeight) + 'px' }"
        ref="gridlayout" 
        v-model:layout="template"
        :col-num="12" 
        :row-height="30"
        :is-draggable="true" 
        :is-resizable="true" 
        :auto-size="true"
        :vertical-compact="true"
        :use-css-transforms="true"
        :isResizable="true"
        :isBounded="true"
        :responsive="false"
        :margin=[3,3]
        
      >
        <grid-item 
          v-for="(item,index) in template" 
          :key="item.i" 
          :x="item.x" 
          :y="item.y" 
          :w="item.w" 
          :h="item.h" 
          :i="item.i"
          :min-y="item.y"
          @mouseover="showInput(index)"
          @mouseleave="hideInput(index)"
        >
          <span class="text">{{ textMapping[item.type] }}</span>
          <span class="remove" @click="removeItem(item.i)">x</span>
          
          <select v-model="item.type" @change="handleTypeChange(item)">
            <option value="">請選取型態</option>
            <option value="time">時間</option>
            <option value="video">影像</option>
            <option value="webpage">網頁</option>
            <!--option value="news">公告</option-->
            <option value="marquee">跑馬燈</option>
            <option value="weather-icons">氣象</option>
            <option value="carousel">圖檔輪放</option>
          </select>
          <input v-if="item.type === 'video'"  v-show="item.showInput" v-model="item.value2" type="text" class="grid-input" placeholder="輸入影像檔案或網址">
          <input v-if="item.type === 'webpage'" v-show="item.showInput" v-model="item.value2" type="url" class="grid-input" placeholder="輸入網址">
          <input v-if="item.type === 'news'" v-show="item.showInput" v-model="item.value2" type="text" class="grid-input" placeholder="輸入網址或文字">
          <div v-if="item.type === 'carousel'" v-show="item.showInput">
           
            <v-row>
              <v-col>
              <v-file-input
                    v-model="files"
                    accept="image/*"
                    placeholder="選擇圖檔"
                    prepend-icon="mdi-image"
                    multiple
                    @change="onFileChange"
                    :rules="[rules.size]"
                  ></v-file-input>
                </v-col>
              </v-row>
                  <v-row>  
                  <v-col>
                    <div class="image-wrapper" >
                      <v-row >
                        <v-col v-for="(image, key) in images" :key="key" cols="auto">
                              
                            <div class="image-holder" >
                              <v-img
                                :ref="'image'"
                                :src="image.url"
                                :alt="'Image ' + (key + 1)"
                                width="320"
                                height="180"
                                class="image1"  
                              />

                              <v-btn
                                v-if="image.url"
                                icon
                                @click.prevent="removeImage(key)"
                                class="remove-btn2"
                                size="small"
                                color="red"
                                variant="text"
                                elevation="2"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
          </div>
          <input v-if="item.type === 'marquee'" v-model="item.value2" type="text" v-show="item.showInput" class="grid-input" placeholder="輸入文字">
          <!--input v-if="item.type === 'time'" v-model="item.value" type="text" v-show="item.showInput" class="grid-input" placeholder="yyyy 月 MM 月 dd 日 HH 時 mm 分 ss 秒"-->
          <div v-if="item.type === 'weather-icons'" class="weather-panel" v-show="item.showInput">
            <div class="icon-selector">
              <div class="custom-select">
              <select v-model="selectedIcon" @change="addIconToPanel(item,selectedIcon)">
                <option value="">請選擇</option>
                <option v-for="icon in iconSelection" 
                        :key="icon.value" 
                        :value="icon">
                  {{ icon.text }}
                </option>
              </select>
              </div>
            </div>

            
            <div class="selected-icons-container">
              <div v-for="iconValue in item.value" 
                   :key="iconValue" 
                   class="selected-icon">
                <!--img :src="`/icons/${iconValue}.png`" 
                     :alt="iconValue"
                     class="icon-image" /-->
                <img :src="typeof iconValue === 'string' ? iconValue.split(',')[2] : iconValue.icon" 
                  :alt="typeof iconValue === 'string' ? iconValue.split(',')[1] : iconValue.value"
                  class="icon-image">
                  <button @click="removeIcon(item,iconValue)" 
                        class="remove-icon"
                        title="移除元件">
                  ×
                </button>
              </div>
            </div>
          </div>
        </grid-item>
      </grid-layout>
      
    </div>
    </div>
    <br>
    <br>
    <!--v-row>
      <v-col cols="2">
    <div @drag="drag" @dragend="dragend" class="droppable-element" draggable="true" unselectable="on">
      點選我並拖曳至上方以增加項目
    </div>
    <br>
    <br>
    <br>
        </v-col>
      </v-row-->
    
  </div>
</template>

<script>
import { ref, defineComponent, onMounted, watch , onUnmounted, computed} from 'vue'
import { GridLayout, GridItem } from 'vue3-grid-layout'
import axios from "axios";
import { useFormStore } from '@/stores/formStore';
//import { useHead } from '@vueuse/head'


export default defineComponent({
  components: {
    GridLayout,
    GridItem
  },
  
  
  setup() {
    /*
    useHead({
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
      ]
    });
    */
    const panelWidth = ref(1080);
    const panelHeight = ref(1920);
    const boxes = ref([]);

    const createPanel = () => {
      
    };

    const template = ref([
      /*
      { x: 0, y: 0, w: 2, h: 4, i: '0', type: '' , value:null},
      { x: 2, y: 0, w: 2, h: 4, i: '1', type: '' , value:null},
      { x: 4, y: 0, w: 2, h: 5, i: '2', type: '' , value:null},
      { x: 6, y: 0, w: 2, h: 3, i: '3', type: '' , value:null},
      { x: 8, y: 0, w: 2, h: 3, i: '4', type: '' , value:null},
      { x: 10, y: 0, w: 2, h: 3, i: '5', type: '' }
       */
    ]);

    // Define available weather icons with proper paths
    const iconSelection = ref([
      /*
      { value: 'airpressure', text: 'Air Pressure', icon: '/icons/airpressure.png' },
      { value: 'airtemperature', text: 'Air Temperature', icon: '/icons/airtemperature.png' },
      { value: 'humidity', text: 'Humidity', icon: '/icons/humidity.png' },
      { value: 'peakgustspeed', text: 'Peak Gust Speed', icon: '/icons/peakgustspeed.png' }
       */
    ]);

    const hostName = window.location.hostname;    
    const port = window.location.port;  
    const images = ref([]);
    const files = ref([]);
    const formStore = useFormStore();
    const selectedIcons = ref([]);
    const selectedIcon = ref(null);
    const selectedTemplateId = ref(null);
    const env = import.meta.env;
    const apiUrl = window.config.API_URL;
    const homeUrl = window.config.HOME_URL;
    const templateName = ref('');
    const templates = ref([]);
    const gridlayout = ref(null);
    const index = ref(0);
    const textMapping= ref({
        'video': '影像',
        'webpage': '網頁',
        'news': '公告',
        'marquee': '跑馬燈',
        'weather-icons': '氣象',
        'time':'時間',
        'carousel':'圖檔輪放',
     });
    const screenWidth=ref(1920*0.95);
    const gridWidth=ref(1080);
    const removeImage = (index)=> {
      images.value.splice(index, 1); // Remove the image visually
      formStore.removeImage(index);
      
    };
    /*
    const dataUrlToFile = async (dataUrl, fileName) => {
      const response = await fetch(dataUrl);
      const blob = await response.blob();
      
      return new File([blob], fileName, {
        type: 'image/jpeg',
        lastModified: new Date().getTime()
      });
    };
    */
    const checkBounds=(layout)=> {
      console.log('checkBound',layout);
      
  const maxCols = Math.floor(panelWidth / 30);
  const maxRows = Math.floor(panelHeight / 30);

  layout.forEach((item) => {
    if (item.x + item.w > maxCols) item.x = maxCols - item.w;
    if (item.y + item.h > maxRows) item.y = maxRows - item.h;
  });
      
      
    };
    const fixExifOrientation = async (imgDataUrl, embeddedDate) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = async () => {
          
          
          const canvas = document.createElement('canvas');
          canvas.width = 320;
          canvas.height = 180;
          const ctx = canvas.getContext('2d');

          
          ctx.fillStyle = 'black';
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          const scale = Math.max(
            canvas.width / img.width,
            canvas.height / img.height
          );
          const x = (canvas.width - img.width * scale) / 2;
          const y = (canvas.height - img.height * scale) / 2;

          
          ctx.drawImage(
            img,
            x,
            y,
            img.width * scale,
            img.height * scale
          );

          //console.log('embddedDate',embeddedDate.value)


          

          resolve(canvas.toDataURL('image/jpeg'));
        };
        img.src = imgDataUrl;
      });
    };

    const titleElement = document.querySelector('h1');

    const openFullScreenWindow = (secs) => {
      //const newWindow = window.open(`${fullUrl}/AhmayDashboard3?name=${templateName.value}&secs=${secs}`, '_blank',`width=${screen.width}, height=${screen.height}, left=0, top=0`);
      const newWindow = window.open(`${homeUrl}/AhmayDashboard3?name=${templateName.value}&secs=${secs}`, '_blank',`width=${screen.width}, height=${screen.height}, left=0, top=0`);
      //const newWindow = window.open(`${homeUrl}/AhmayDashboard3/${templateName.value}/${secs}`, '_blank',`width=${screen.width}, height=${screen.height}, left=0, top=0`);

      newWindow.addEventListener('click', () => {
        // Attempt to request full screen after the new window has fully loaded content
        newWindow.document.documentElement.requestFullscreen().catch(err => {
          console.error('Error attempting to enable full-screen mode:', err);
        });
        const enterFullScreen = () => {
          if (newWindow.document.documentElement.requestFullscreen) {
            newWindow.document.documentElement.requestFullscreen();
          } else if (newWindow.document.documentElement.mozRequestFullScreen) { // Firefox
            newWindow.document.documentElement.mozRequestFullScreen();
          } else if (newWindow.document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
            newWindow.document.documentElement.webkitRequestFullscreen();
          } else if (newWindow.document.documentElement.msRequestFullscreen) { // IE/Edge
            newWindow.document.documentElement.msRequestFullscreen();
          } else {
            console.warn('Fullscreen API is not supported.');
          }
        };

        // Check if the fullscreen API call is successful
        try {
          enterFullScreen();
        } catch (err) {
          console.error('Error trying to enter full-screen mode:', err);
        }
      });
    };

    const previewResult = async()=>{
      if (templateName.value!==null && templateName!=undefined && templateName.value!=='')
      {
        //const url = `${fullUrl}/AhmayDashboard3?name=${templateName.value}&secs=5`; 
        //window.open(url, '_blank'); 
        openFullScreenWindow(5);
      }
      else
      {
        alert('請先載入模板');
      }
    };

    const fullUrl = computed(() => {
      const protocol = window.location.protocol;  
      const portPart = port ? `:${port}` : '';   
      //alert(port);
      //alert(`${protocol}//${hostName}${portPart}`);
      return `${protocol}//${hostName}${portPart}`;  
    });

    const dataUrlToFile = async (dataUrl, fileName) => {
      const response = await fetch(dataUrl);
      const blob = await response.blob();
      
      return new File([blob], fileName, {
        type: 'image/jpeg',
        lastModified: new Date().getTime()
      });
    };

    /*
    const dataUrlToFile = async (dataUrl, fileName) => {
  const img = new Image();

  return new Promise((resolve, reject) => {
    img.onload = async () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set fixed dimensions
      const TARGET_WIDTH = 1080;
      const TARGET_HEIGHT = 720;
      canvas.width = TARGET_WIDTH;
      canvas.height = TARGET_HEIGHT;

      // Fill background with black
      ctx.fillStyle = 'black';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Calculate dimensions to maintain aspect ratio and cover the canvas
      const imageAspect = img.width / img.height;
      const canvasAspect = TARGET_WIDTH / TARGET_HEIGHT;
      
      let renderWidth = TARGET_WIDTH;
      let renderHeight = TARGET_HEIGHT;
      let offsetX = 0;
      let offsetY = 0;

      if (imageAspect > canvasAspect) {
        // Image is wider than canvas aspect ratio
        renderHeight = TARGET_HEIGHT;
        renderWidth = renderHeight * imageAspect;
        offsetX = (TARGET_WIDTH - renderWidth) / 2;
      } else {
        // Image is taller than canvas aspect ratio
        renderWidth = TARGET_WIDTH;
        renderHeight = renderWidth / imageAspect;
        offsetY = (TARGET_HEIGHT - renderHeight) / 2;
      }

      // Draw the image maintaining aspect ratio
      ctx.drawImage(
        img,
        offsetX,
        offsetY,
        renderWidth,
        renderHeight
      );

      resolve(canvas.toDataURL('image/jpeg', 0.9));
    };

    img.onerror = (error) => {
      reject(new Error(`Failed to load image: ${error}`));
    };

    img.src = dataUrl;
  });
};
    */

   const processImage =async (file)=> {
    const imageUrl = URL.createObjectURL(file);

    return new Promise((resolve) => {
      const img = new Image();
      img.onload = async () => {
        

        //resolve({ url: imageUrl, originalWidth: img.width > 320 ? 320:img.width, originalHeight: img.height > 180? 180 :img.height});
        resolve({ url: imageUrl});
      };
      img.src = imageUrl;
    });
  };



    const onFileChange = async (event) => {
      const files = event.target.files;
      for (const file of files) {
        const imageUrl = URL.createObjectURL(file);
        const processedImageDataUrl = await fixExifOrientation(imageUrl,false);
        //const processedImageDataUrl = await processImage(file);
        const processedFile = await dataUrlToFile(processedImageDataUrl, file.name);
        images.value.push({ url: processedImageDataUrl, processedFile });
        //console.log(images.value);
        formStore.addImage(processedFile);

        //console.log('processedFile',processedFile);
        /*
        const imageUrl = URL.createObjectURL(file);
        images.value.push({ url: imageUrl, file });
        formStore.addImage(file);
        */
      }
    };

    const rules = {
      size: value => {
        if (!value) return true;
        for (const file of value) {
          const size = file.size / 1024 / 1024;
          if (size > 5) {
            return '照片大小不能超過 5MB';
          }
        }
        return true;
      },
    };

    const drag = (e) => {
      // Get the grid's DOM element
      const gridLayoutElement = gridlayout.value.$el
      // Get element's bounding box
      const rect = gridLayoutElement.getBoundingClientRect()
      
      // Calculate position relative to the grid
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      
      // Update position
      e.dataTransfer.setData('text/plain', 'grid-item')
      e.dataTransfer.effectAllowed = 'move'
    }

    

    const dragend = (e) => {
      /*
      const rect = gridlayout.value.$el.getBoundingClientRect()
      let mouseInGrid = false;
      if (((e.clientX > rect.left) && (e.clientX < rect.right)) && ((e.clientY > rect.top) && (e.clientY < rect.bottom))) {
          mouseInGrid = true;
      }
      console.log('mouseInGrid',mouseInGrid);
      if (mouseInGrid) {
        const x = Math.round((e.clientX - rect.left) / (rect.width / 12))
        const y = Math.round((e.clientY - (rect.top+rect.height)) / 30)
        const newItem = {
          x: x,
          y: y,
          w: 3,
          h: 4,
          i: index.value.toString(),
          showInput: true,
        }
        
        index.value=template.value.length;
        template.value.push(newItem);
        index.value++;
      }
      */
      
      const rect = gridlayout.value.$el.getBoundingClientRect()
      
      const x = Math.round((e.clientX - rect.left) / (rect.width / 12));
      const y = Math.round((e.clientY - rect.top) / 30);
      console.log(x,y);
      if (x >= 0 && x < 12 && y-4 >= 0) {
        console.log('add new item');
        index.value=template.value.length;
        index.value++;
        const newItem = {
          x: x,
          y: y,
          w: 3,
          h: 4,
          i: index.value.toString(),
          showInput: true,
        }
        
        
        template.value.push(newItem);
        
      }
      
    }

    const carouselItems = ref([]);
    const newItem = ref({
      image: '',
    });

    const addCarouselItem = () => {
      if (newItem.value.image) {
        carouselItems.value.push({ ...newItem.value });
        newItem.value.image = '';
      }
    };

    const removeCarouselItem = (index) => {
      carouselItems.value.splice(index, 1);
    };

    const addIconToPanel = (item,selectedIcon) => {
      if (!selectedIcon || !item) return;
  
      if (!Array.isArray(item.value)) {
        item.value = [];
      }
      console.log('item',item);
      console.log('selectdIcon',selectedIcon);
      const iconString = selectedIcon.text +','+ selectedIcon.value + ',' + selectedIcon.icon;
      const iconExists = item.value.some(icon => 
        typeof icon === 'string' ? icon === iconString : (icon.value + ',' + icon.icon) === iconString
      );
      
      if (!iconExists) {
        item.value.push(iconString);
        console.log('new item',item.value);
      }
    };

    const removeIcon = (item,iconToRemove) => {
      if (!item || !item.value || !Array.isArray(item.value)) return;
  
      item.value = item.value.filter(icon => icon !== iconToRemove);
      console.log('remove',selectedIcons.value);
      console.log('remove',item.value);
    };

    const handleTypeChange = (item) => {
      console.log('handleTypeChange',item);
      switch (item.type) {
        case "video":
          item.value = []; 
          item.value2='';
          break;
        case "webpage":
          item.value = []; 
          item.value2='';
          break;
        case "news":
          item.value = [];
          item.value2=''; 
          break;
        case "marquee":
          item.value = [];
          item.value2=''; 
          break;
        case "weather-icons":
          item.value = [];
          item.value2=''; 
          break;
        default:
          item.value = [];
          item.value2='';
      }
      /*
      if (item.type === 'weather-icons') {
        // Initialize weather icons array if not present
        if (!item.weatherIcons) {
          item.weatherIcons = [];
        }
      } else {
        // Reset other properties when type changes
        item.weatherIcons = [];
        item.mp4 = '';
        item.url = '';
        item.newsFile = '';
        item.text = '';
      }
      */
    };

    
    const removeItem = (val) => {
      const index = template.value.map((item) => item.i).indexOf(val);
      if (index > -1) {
        template.value.splice(index, 1);
      }
    };


    const loadTemplate = async () => {
      if (!selectedTemplateId.value){
        alert('請選擇模版名稱');
        return;
      }
      try {
        //const response = await fetch(`/api/templates/${selectedTemplateId.value}`);
        const response  = await axios.post(`${apiUrl}/template/getTemplate2?id=${selectedTemplateId.value}`);
        console.log('response data',response.data);
        console.log('response ok',response.ok);
        /*
        if (!response.ok) {
          throw new Error('Failed to load template');
        }
        */
        const data = response.data;
        console.log('data.template.layoutJson',data.template.layoutJson);
        if (data) {
            template.value=[];
            selectedIcons.value=[];
            formStore.clearData();
            console.log('data', data)
            const layoutData = JSON.parse(data.template.layoutJson);
          console.log('layout data',layoutData);
          templateName.value = data.template.name;
          
          panelWidth.value = data.template.width || 1920;
          panelHeight.value = data.template.height || 1080;
        

        selectedIcon.value=[];
          let index1=0;
          index.value=layoutData.length;
          console.log('layoutData.width',data.template.width);
          console.log('layoutData.height',data.template.height);
          panelWidth.value=data.template.width;
            panelHeight.value=data.template.height;
          layoutData.forEach(item => {
            console.log('item',item);
            
            const newItem = {
          x: item.x,
          y: item.y,
          w: item.w,
          h: item.h,
          i: item.i,
          type: item.type,
          value: null,
          value2: '',
          showInput: false,
        };

            if (item.type === 'weather-icons') {
              
              newItem.value = Array.isArray(item.value) ? [...item.value] : [];
              console.log('Weather icons loaded:', newItem.value);
              
            }
            else
            {
              newItem.value2 = item.value2;
            }
            
            template.value[index1++] = newItem;
            console.log('all template',template.value);
          });
        
          console.log(response.data.lstImageData);
          const dbImages = await Promise.all(response.data.lstImageData.map(async image => {
            
            const response = await fetch(`data:image/jpeg;base64,${image}`);
            const blob = await response.blob();
            
            const file = new File([blob], `image_${image.id}.jpg`, { type: 'image/jpeg' });
            
            return {
              url: URL.createObjectURL(file),
              file: file,
            };
          }));
          console.log('lstImageData', dbImages);
        //images.value = [...images.value, ...dbImages];
        
          images.value = [];
          dbImages.forEach(imageFile => {
            console.log('imageFile',imageFile);
            images.value.push(imageFile);
            formStore.addImage(imageFile.file);
          });
        }
        /*
        // Process the template content
        const processedTemplate = data.templateContent.map(item => {
          // Add UI properties
          const processedItem = { ...item, showInput: false };
          
          return processedItem;
        });
        
        // Set the template
        template.value = processedTemplate;
        */
      } catch (error) {
        console.error('Error loading template:', error);
        alert(`Error loading template: ${error.message}`);
      }
    };
    const showInput=(index)=> {
      template.value[index].showInput = true;
    };
    const hideInput=(index)=> {
      template.value[index].showInput = false;
    };


    const normalizeItems = (items) => {
      return items.value.map(item => {
        // Ensure the value is always an array
        if (!Array.isArray(item.value)) {
          item.value = [item.value || '']; 
        }
        return item;
      });
    };

    const normalizeItems2 = (items) => {
      return items.map(item => {
        if (item.type !== "weather-icons") {
          console.log('item.value',item.value);
          item.value = item.value.map(videoValue => ({
            value: videoValue,
            text: "",
            icon: ""
          }));
        }
        return item;
      });
    };


    // Function to save a template
const saveTemplate = async () => {
  if (templateName.value===undefined || templateName.value===null ||  templateName.value==='')
  {
    alert('請輸入模版名稱');
    return;
  }

  try {
    // Make sure all template items have their values in the right format
    const formattedTemplate = template.value.map(item => {
      // Make a copy of the item to avoid modifying the original
      const formattedItem = { ...item };
      
      // Handle weather-icons separately
      if (item.type === 'weather-icons') {
        // Ensure item.value is an array
        if (!Array.isArray(item.value)) {
          formattedItem.value = [];
        }
      } 
      // For other types that should have a string value
      else if (['video', 'news', 'marquee', 'time'].includes(item.type)) {
        if (Array.isArray(item.value)) {
          // If it's an array but should be a string, use the first item or empty string
          formattedItem.value = item.value.length > 0 ? item.value[0].value : '';
        }
      }
      console.log('before saving',formattedItem);
      // Remove UI-only properties that shouldn't be saved
      delete formattedItem.showInput;
      
      return formattedItem;
    });
    
    const templateData = {
      id: (selectedTemplateId.value || 0).toString(),
      name: templateName.value,
      templateContent: JSON.stringify(formattedTemplate),
      width: panelWidth.value,
      height: panelHeight.value,
//      layoutJson: JSON.stringify( formattedTemplate)
    };
    
    const formData = new FormData();
  
      formData.append('id', templateData.id);
      formData.append('name', templateData.name);
      formData.append('layoutJson', templateData.templateContent);
      formData.append('width',panelWidth.value);
      formData.append('height',panelHeight.value);
      //if (templateData.images) {
      //  console.log('processing images', templateData.images.length);
        formStore.images.forEach((image) => {
          formData.append('images', image);
        });

    try {
        const response = await axios.post(`${apiUrl}/template/save3`, formData, {
          headers: {
            //'Content-Type': 'multipart/form-data'
          }
        });
        
        alert('儲存完成');
        try
        {
          formStore.clearData();
        }
        catch(e)
        {
          console.log('clear store',e);
        }
        template.value = [];
        templates.value = [];

        loadTemplates();
        templateName.value='';

        return response.data;
      } catch (error) {
        alert('儲存失敗:', error+","+response.data);
        throw error;
      }
      finally{
        
        
      }
    
  } catch (error) {
    console.error('Error saving template:', error);
    alert(`Error saving template: ${error.message}`);
  }
  
};


const loadTemplates = async () => {
      try {
        const response = await axios.get(`${apiUrl}/template/getTemplates`);
        //console.log("B:", JSON.stringify(response.data, null, 2));
        //console.log('response.data',response.data);
        templates.value=[];
        template.value=[];
        const data = response.data;
        //console.log('data',data);
        //console.log('data len',data.length);
        //index.value=data.length;
        console.log('index',index.value);
        for(var i=0;i<data.length;i++)
        {
          //console.log(`data${i}`,data[i]);
          //console.log('id',data[i].id);
          //console.log('name',data[i].name);
          templates.value.push({
            id: data[i].id,
            name:data[i].name
            }
          );
        
        } 
        

        console.log('templates',templates.value);
        

      } catch (error) {
        console.error("Error loading templates:", error);
      }
    };
    
    

    const deleteTemplate = async () => {
      if (selectedTemplateId===undefined || selectedTemplateId==='')
      {
        alert('請選擇模版名稱');
        return;
      }

      if (!confirm("確定要刪除模版?")) return;

      try {
        //const response  = await axios.delete(`${apiUrl}/template/deleteTemplate?id=${selectedTemplateId.value}`);
        const found=templates.value.find((x)=>x.id===selectedTemplateId.value);
        const encodedName = encodeURIComponent(found.name);
        console.log('name',encodedName);
        const response  = await axios.post(`${apiUrl}/template/deleteTemplate?id=${selectedTemplateId.value}&name=${encodedName}`);
        selectedTemplateId.value = null;
        template.value = [];
        templates.value = [];
        try
        {
          formStore.clearData();
        }
        catch(e)
        {
          console.log('clear store',e);
        }
        loadTemplates();
      } catch (error) {
        console.error("Error deleting template:", error);
      }
    };

    const deleteAllTemplate = async () => {
      if (templates.value.length <= 0)
      {
        return;
      }

      if (!confirm("確定要清除編輯區?")) return;

      try {
        
        template.value = [];
        templates.value = [];
        try
        {
          formStore.clearData();
        }
        catch(e)
        {
          console.log('clear store',e);
        }
        
      } catch (error) {
        console.error("Error deleting template:", error);
      }
    };
    /*
    const loadTemplate = async (templateId) => {
      try {
        const response = await axios.get(`/api/template/${templateId}`);
        const templateData = response.data;
        
        // Update layout with loaded data
        layout.value = templateData.layout.map(item => ({
          ...item,
          // Restore panel specific data
          weatherIcons: item.content?.weatherIcons || [],
          url: item.content?.url || '',
          mp4: item.content?.mp4 || '',
          newsFile: item.content?.newsFile || '',
          text: item.content?.text || ''
        }));
      } catch (error) {
        console.error('Error loading template:', error);
        throw error;
      }
    };

    const saveTemplate = async () => {
      try {
        const templateData = {
          layout: layout.value.map(item => ({
            ...item,
            content: getItemContent(item)
          }))
        };

        await axios.post('/api/templates', templateData);
        console.log('Template saved successfully');
      } catch (error) {
        console.error('Error saving template:', error);
        throw error;
      }
    };
    */
    const savePanelContent = async (panelId) => {
      try {
        const panel = template.value.find(item => item.i === panelId);
        if (!panel) return;

        console.log('panel content',getItemContent(panel));
        const panelData = {
          id: panelId,
          type: panel.type,
          content: getItemContent(panel)
        };

        await axios.post(`/api/panels/${panelId}`, panelData);
        console.log('Panel content saved successfully');
      } catch (error) {
        console.error('Error saving panel content:', error);
        throw error;
      }
    };
    
    const getItemContent = (item) => {
      switch (item.type) {
        case 'weather-icons':
          return {
            weatherIcons: Array.isArray(item.weatherIcons) ? item.weatherIcons : []
          };
        case 'video':
          return {
            mp4: Array.isArray(item.mp4) ? item.mp4 : [item.mp4 || '']
          };
        case 'webpage':
          return {
            url: Array.isArray(item.url) ? item.url : [item.url || '']
          };
        case 'news':
          return {
            newsFile: Array.isArray(item.newsFile) ? item.newsFile : [item.newsFile || '']
          };
        case 'marquee':
          return {
            text: Array.isArray(item.text) ? item.text : [item.text || '']
          };
        default:
          return {};
      }
    };


    const autoSave = async (item) => {
      await savePanelContent(item.i);
    };

    
    const loadIcon = async () => {
    try {
      const response = await axios.get(`${apiUrl}/template/getIcons`);
      iconSelection.value = response.data;
      //console.log('iconSelection', iconSelection.value)
    } catch (error) {
      console.error('Error loading layout:', error);
    }
  };

  const updateGridWidth= ()=> {
      //gridWidth.value= window.innerWidth;
      //console.log('gridWidth',gridWidth.value);
    };
  
  onMounted(() => {
   
      //alert(window.innerWidth);
      screenWidth.value=Math.round(window.innerWidth*0.95);
      const maxIndex = template.value.reduce((max, item) => {
        const currentIndex = parseInt(item.i);
        return currentIndex > max ? currentIndex : max;
      }, -1);
      
      index.value = maxIndex + 1;
      loadIcon();
      loadTemplates();
      window.addEventListener('resize', updateGridWidth);
  });

  

  onUnmounted(() => {
   
      
   
   window.removeEventListener('resize', updateGridWidth);
});


    return {
      processImage,
      showInput,
      hideInput,
      checkBounds,
      fixExifOrientation,
      onFileChange,
      selectedTemplateId,
      template,
      gridlayout,
      removeItem,
      handleTypeChange,
      iconSelection,
      selectedIcons,
      selectedIcon,
      addIconToPanel,
      removeIcon,
      loadTemplate,
      saveTemplate,
      deleteTemplate,
      deleteAllTemplate,
      drag,
      dragend,
      templateName,
      templates,
      textMapping,
      files,
      images,
      rules,
      dataUrlToFile,
      removeImage,
      panelWidth,
      panelHeight,
      createPanel,
      gridWidth,
      previewResult,
      openFullScreenWindow,
    };
  }
});
</script>

<style>

body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0;
}

* {
  
  box-sizing: border-box;
  
}

.full-width-grid-layout {
  width: 100%;
  background: white;
}

.container {
  
  overflow: hidden; 
  white-space: nowrap; 
  flex: none;
  display: block;
  margin: 0;
}

.content{
  width:100%;
  overflow: auto;
  border: 2px solid blue;
  background-color: green;
}

.panel {
  width: 100%;
  height: 103%;
  border: 2px solid burlywood;
  position: relative;
  margin: 0;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: white;
}


.remove-btn {
  position: absolute; 
  top: 5px; 
  right: 5px; 
  z-index: 10; 
}

.image-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  margin-bottom: 16px;
}

.remove-btn-container {
  flex-shrink: 0;
}

.remove-btn2 {
  position: absolute !important;
  top: 8px;
  right: 8px;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0,0,0,0.8) !important;
}

.remove-btn:hover {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.image-holder {
  position: relative;
  /*width: auto;
  height:auto;*/
  /*max-width: 1080px;*/
  /*padding-bottom: 56.25%;*//* 16:9 aspect ratio */
  /*
  overflow: hidden;
  border-radius: 8px;
  
  */
  background-color: #000;
}

.gallery-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain; 
  
}

.layoutJSON {
  background: black;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.columns {
  display: flex;
  flex-wrap: wrap;
}

.layoutItem {
  margin: 0px;
}

.droppable-element {
  width: 300px;
  text-align: center;
  background: lightgray;
  border: 1px solid white;
  margin: 0;
  padding: 10px;
  cursor: move;
  font-size: larger;
  color:black;
}


:root {
  --dark-bg: #1a1a1a;
  --dark-surface: #2d2d2d;
  --dark-border: #404040;
  --dark-text: #e0e0e0;
  --dark-text-secondary: #a0a0a0;
  --dark-primary: #3d5afe;
  --dark-hover: #3d3d3d;
  --dark-danger: #ff4444;
}



.custom-select {
  position: relative;
  width: 100%;
}

.custom-select select {
  width: 100%;
  padding: 8px 32px 8px 12px; /* Increased right padding for arrow */
  background: var(--dark-bg);
  color: var(--dark-text);
  border: 1px solid var(--dark-border);
  border-radius: 4px;
  appearance: none; /* Remove default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

.custom-select::after {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--dark-text);
  pointer-events: none;
}

.custom-select select:hover {
  border-color: var(--dark-primary);
}

.custom-select select:focus {
  border-color: var(--dark-primary);
  outline: none;
  box-shadow: 0 0 0 1px var(--dark-primary);
}

.weather-panel {
  padding: 10px;
  margin-top: 0px;
  background: var(--dark-surface);
  color: var(--dark-text);
  border-radius: 8px;
}

.icon-selector {
  margin-top: 10px;
}

.selected-icons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px;
  background: var(--dark-bg);
  border-radius: 6px;
  border: 1px solid var(--dark-border);
}

.selected-icon {
  position: relative;
  width: 30px;
  height: 50px;
  background: var(--dark-surface);
  padding: 6px;
  border-radius: 6px;
  border: 1px solid var(--dark-border);
}


.weather-panel {
  padding: 10px;
  margin-top: 20px;
  background: var(--dark-surface);
  color: var(--dark-text);
  border-radius: 8px;
}



.icon-selector select {
  width: 100%;
  padding: 8px;
  background: var(--dark-bg);
  color: var(--dark-text);
  border: 1px solid var(--dark-border);
  border-radius: 4px;
}

.icon-selector select:focus {
  border-color: var(--dark-primary);
  outline: none;
}

.icon-selector select option {
  background: var(--dark-bg);
  color: var(--dark-text);
}

.selected-icons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px;
  background: var(--dark-bg);
  border-radius: 6px;
  border: 1px solid var(--dark-border);
}

.selected-icon {
  position: relative;
  width: 50px;
  height: 50px;
  background: var(--dark-surface);
  padding: 6px;
  border-radius: 6px;
  border: 1px solid var(--dark-border);
}

.icon-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: brightness(0.9); 
}

.remove-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--dark-danger);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: background-color 0.2s;
}

.remove-icon:hover {
  background: #ff6666;
}


.vue-grid-layout {
  background: var(--dark-bg);
  
}

.vue-grid-item {
  background: var(--dark-surface);
  border: 1px solid var(--dark-text-secondary);
  padding: 12px;
  border-radius: 8px;
  color: var(--dark-text);
}

.vue-grid-item:hover {
  border-color: var(--dark-primary);
}


.vue-grid-item select {
  width: 100%;
  padding: 8px;
  margin-top: 24px;
  background: var(--dark-bg);
  color: var(--dark-text);
  border: 1px solid var(--dark-border);
  border-radius: 4px;
}

.vue-grid-item select:focus {
  border-color: var(--dark-primary);
  outline: none;
}

.vue-grid-item .add {
    cursor: pointer;
}

.vue-draggable-handle {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}


.text {
  font-size: 24px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 24px;
  color: var(--dark-text);
  text-align: center;
  width: 100%;
  padding: 5px 0;
}


.remove {
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  color: var(--dark-danger);
  font-size: 16px;
  font-weight: bold;
  transition: color 0.2s;
}

.remove:hover {
  color: #ff6666;
}

.vue-grid-item.vue-grid-placeholder {
  background: var(--dark-primary);
  opacity: 0.2;
  border-radius: 8px;
}

.grid-input {
  position: absolute;
  top: 80px; 
  left: 0;
  width: calc(100% - 20px); 
  margin: 10px;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 1; 
}
.image-wrapper {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 600px;
}

</style>

